import get from 'lodash/get';
import Pusher from 'pusher-js';
import type { Pusher as PusherType } from 'pusher-js';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import type { Dispatch, ReactNode, SetStateAction } from 'react';

type Props = {
  children: ReactNode,
  config: {
    key: string,
    options: {},
  },
  enabled: boolean,
};

export const SocketContext = createContext<{
  pusher?: PusherType,
  setReadyStatus?: Dispatch<SetStateAction<boolean>>,
}>({});

export const SocketProvider = ({ children, config, enabled }: Props) => {
  const [pusher, setPusher] = useState<PusherType>();
  const [isReady, setReadyStatus] = useState(false);

  useEffect(() => {
    if (!pusher && get(config, 'key') && enabled && !isReady) {
      setPusher(new Pusher(get(config, 'key'), get(config, 'options')));
    }

    if (pusher && get(pusher, 'connection.state') !== 'connected' && isReady) {
      pusher.connect();
    }
  }, [config, enabled, isReady, pusher]);

  const value = useMemo(() => ({ pusher, setReadyStatus }), [pusher, setReadyStatus]);

  return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>;
};

export const useSocket = () => useContext(SocketContext);
